module.exports = { id: "frame-dames", url: "/build/app/img/symbols.svg#frame-dames", viewBox: "", toString: function() { return this.url; } };